import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d5acd9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-button-txt" }

import SvgIcon from '../svgicons/SvgIcon.vue';
import { computed } from 'vue';

interface ButtonProps {
  text?: string,
  icon?: string,
  type?: string,
  size?: string,
  disabled?: boolean
}

const __default__ = {
  name: 'CButton'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    text: { default: '' },
    icon: null,
    type: null,
    size: { default: 'default' },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { text: string, icon?: string, type?: string, size: string, disabled: boolean };


const btnClass = computed(() => {
  return {
    'c-primary-btn': props.type == 'primary',
    'c-danger-btn': props.type == 'danger',
    'c-large-btn': props.size == 'large',
    'c-small-btn': props.size == 'small',
    'c-btn-disabled': props.disabled
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-button", _unref(btnClass)])
  }, [
    (__props.icon)
      ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          class: "c-button-icon",
          icon: __props.icon
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.text), 1)
      ])
    ])
  ], 2))
}
}

})